var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "currentColor",
    d: "M12.4966 18.3332V14.9998C12.6125 13.9559 12.3132 12.9083 11.6632 12.0832C14.1632 12.0832 16.6632 10.4165 16.6632 7.49984C16.7299 6.45817 16.4382 5.43317 15.8299 4.58317C16.0632 3.62484 16.0632 2.62484 15.8299 1.6665C15.8299 1.6665 14.9966 1.6665 13.3299 2.9165C11.1299 2.49984 8.86324 2.49984 6.66324 2.9165C4.99657 1.6665 4.16324 1.6665 4.16324 1.6665C3.91324 2.62484 3.91324 3.62484 4.16324 4.58317C3.55647 5.42974 3.26197 6.46049 3.32991 7.49984C3.32991 10.4165 5.82991 12.0832 8.32991 12.0832C8.00491 12.4915 7.76324 12.9582 7.62157 13.4582C7.47991 13.9582 7.43824 14.4832 7.49657 14.9998V18.3332",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5013 15.0002C3.74297 16.6668 3.33464 13.3335 1.66797 13.3335",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/GitHub.3abf3dbd4cfa6b38ffe6567294806a1e.svg";
export { ForwardRef as ReactComponent };